
<div class="pipeline-card" :type="type" @click="handleClick($event)">
	<div class="pipeline-card-header">
		<!-- @slot Used to display pipeline card header -->
		<slot name="header" />
	</div>
	<div class="pipeline-card-body">
		<!-- @slot Used to display pipeline card content <br/> e.g. LabelValue component is used display key value data   -->
		<slot />
	</div>
	<div class="pipeline-card-footer">
		<!-- @slot Used to display pipeline card footer <br/> e.g. PipelineNumberStat and AlarmCircle is used display big number stats and alarm -->
		<slot name="footer" />
	</div>
</div>
